import API_URL from '../../api/APIUrl';
import StudentRow from './StudentRow';
import { useState, useEffect } from 'react';
import { useStudentContext } from './useStudentContext';
import SideMenu from '../SideMenu';
import { useAuthContext } from '../../adminlogin/useAuthContext';

const ManageStudent = () => {
    const { adminuser } = useAuthContext();
    const { students, dispatch } = useStudentContext();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPending, setIsPending] = useState(true);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [statusFilter, setStatusFilter] = useState('ALL'); // New state for status filter

    useEffect(() => {
        const fetchStudents = async () => {
            const response = await fetch(API_URL.GET_ALL_STUDENTS + "?p=" + currentIndex, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${adminuser.token}`
                }
            });

            const json = await response.json();

            if (response.ok) {
                setIsPending(false);
                setError(null);
                dispatch({ type: 'SET_STUDENTS', payload: json });
            } else {
                dispatch({ type: 'SET_STUDENTS', payload: null });
                setIsPending(false);
                setError('No data found!');
            }
        };

        fetchStudents();
    }, [dispatch, currentIndex]);

    const handlePrevClick = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
        } else {
            alert("No further records");
        }
    };

    const handleNextClick = () => {
        if (students) {
            setCurrentIndex(currentIndex + 1);
        } else {
            alert("No further records");
        }
    };

    // Filter students based on search and status
    const filteredStudents = students?.filter(student => 
        (statusFilter === 'ALL' || student.admin_status === statusFilter) &&
        Object.values(student).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );


// Utility to convert JSON to CSV
const downloadCSV = () => {
    if (!filteredStudents?.length) return;

    const headers = ["Code", "Full Name", "Email", "WhatsApp", "Created At", "Status"];
    const rows = filteredStudents.map(student => [
        student.code,
        `${student.firstname} ${student.surname}`,
        student.email,
        student.student_whatsapp,
        new Date(student.createdAt).toLocaleString(),
        student.admin_status
    ]);

    const csvContent = [
        headers.join(","),
        ...rows.map(row => row.map(field => `"${String(field).replace(/"/g, '""')}"`).join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "students.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};


    return (
        <>
            <div className="d-flex">
                <SideMenu />

                <div id="page-content-wrapper" style={{ flex: 1, padding: '20px' }}>
                    <div className="container-fluid">
                        <h2>Manage Applications</h2>

                        {/* Search and Filter Section */}
                        <div className="row mb-3">
                            <div className="col-md-4">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search by any field..."
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                            </div>
                            <div className="col-md-4">
                                <select
                                    className="form-control"
                                    value={statusFilter}
                                    onChange={(e) => setStatusFilter(e.target.value)}
                                >
                                    <option value="ALL">All</option>
                                    <option value="APPROVED">Approved</option>
                                    <option value="REJECTED">Rejected</option>
                                </select>
                            </div>

                            <div className="col-md-4">
                                <div className="text-right mb-4">
                                        <button className="btn btn-success" onClick={downloadCSV}>
                                            Download CSV
                                        </button>
                                </div>
                            </div>

                        </div>

                      

                        {/* Student Table */}
                        <div className="table-responsive">
                            <table className="table table-bordered table-striped table-hover text-center">
                                <thead className="thead-dark">
                                    <tr>
                                        <th scope="col">Code</th>
                                        <th scope="col">Full Name</th>
                                        <th scope="col">Email</th>
                                        <th scope="col">WhatsApp</th>
                                        <th scope="col">Created At</th>
                                        <th scope="col">Deadline</th>
                                        <th scope="col">Amount Needed</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {error && (
                                        <tr>
                                            <td colSpan={7} className="text-danger text-center">{error}</td>
                                        </tr>
                                    )}
                                    {isPending && (
                                        <tr>
                                            <td colSpan={7} className="text-primary text-center">Loading...</td>
                                        </tr>
                                    )}
                                    {filteredStudents &&
                                        filteredStudents.map((student) => (
                                            <StudentRow
                                                key={student._id}
                                                id={student._id}
                                                code={student.code}
                                                firstname={student.firstname}
                                                surname={student.surname}
                                                city={student.city}
                                                sub_caste={student.sub_caste}
                                                email={student.email}
                                                admin_status={student.admin_status}
                                                student_whatsapp={student.student_whatsapp}
                                                createdAt={student.createdAt}                                                
                                                total_fees={student.total_fees}
                                                arranged_amount={student.arranged_amount}
                                                payment_deadline={student.payment_deadline}

                                            />
                                        ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <nav className="mt-3">
                            <ul className="pagination justify-content-center">
                                <li className="page-item">
                                    <button className="page-link" onClick={handlePrevClick} disabled={currentIndex === 0}>
                                        Previous
                                    </button>
                                </li>
                                <li className="page-item">
                                    <button className="page-link" onClick={handleNextClick} disabled={!students?.length}>
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ManageStudent;
